export * from '@fhs/routing/src/routes/store-locator/store/[idOrNumber]/[slug]';
export { default } from '@fhs/routing/src/routes/store-locator/store/[idOrNumber]/[slug]';
